import { render, staticRenderFns } from "./BarraSaldo.vue?vue&type=template&id=3077305b"
import script from "./BarraSaldo.vue?vue&type=script&lang=js"
export * from "./BarraSaldo.vue?vue&type=script&lang=js"
import style0 from "./BarraSaldo.vue?vue&type=style&index=0&id=3077305b&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports